import React, { useCallback, useRef } from 'react';
import ThumbIconButton from '@wix/da-ds/pkg/thumbs/ThumbIconButton';
import { useFaveButton } from '../../../../FaveButton/useFaveButton';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
var FaveControl = function (_a) {
    var deviation = _a.deviation, _b = _a.showStatNumbers, showStatNumbers = _b === void 0 ? true : _b, className = _a.className;
    var buttonRef = useRef(null);
    var showStats = useOverlayContext(deviation).showStats;
    var _c = useFaveButton(deviation), isFavourite = _c.isFavourite, faveCount = _c.faveCount, onFaveClick = _c.onClick, biData = _c.biData;
    var handleClick = useCallback(function () {
        onFaveClick();
        if (buttonRef.current) {
            buttonRef.current.blur();
        }
    }, [onFaveClick]);
    return (React.createElement(ThumbIconButton, { ref: buttonRef, className: className, type: "fave", isEngaged: isFavourite, showStatValue: showStats && showStatNumbers, statValue: faveCount, onClick: handleClick, biData: biData }));
};
FaveControl.displayName = 'FaveControl';
export default FaveControl;
//# sourceMappingURL=FaveControl.js.map